export const registerServiceWorker = async () => {
  // TODO: Uncomment once we get QA ssl cert covering whitelabelled subdomains
  // return new Promise<void>((resolve, reject) => {
  //   if ('serviceWorker' in navigator) {
  //     window.addEventListener('load', () => {
  //       navigator.serviceWorker
  //         .register('/service-worker.js')
  //         .then(() => {
  //           resolve();
  //         })
  //         .catch(error => {
  //           console.log('ServiceWorker registration failed: ', error);
  //           reject();
  //         });
  //     });
  //   } else {
  //     resolve();
  //   }
  // });
};
